import "aos/dist/aos.css";
import { useEffect, useState, useRef } from "react";
import Header from "./dashboard/header";
import getContract, { getIpToken } from "../services/contract";
import { ethers } from "ethers";
import { FaRocket } from "react-icons/fa";
import { IoMdSwap } from "react-icons/io";
import { FaMoneyCheckDollar } from "react-icons/fa6";
import { FaClipboardList } from "react-icons/fa";
import { FaFlagCheckered } from "react-icons/fa";
import { MdGeneratingTokens } from "react-icons/md";
import { FaUserLock } from "react-icons/fa";
import { FaUsers } from "react-icons/fa";
import Footer from "./footer";
import AOS from "aos";
import { TransactionService } from '../services/transactionService'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import getWallet, { disconnectWallet, onChange } from '../services/wallet';
import getTokenContract from '../services/tokenContract';
import { useNavigate, useLocation } from "react-router-dom";
import queryString from 'query-string';
import {
  AiFillAccountBook,
  AiFillCopy,
  AiOutlinePaperClip,
  AiOutlineShareAlt,
} from "react-icons/ai";

const Home = (props) => {
  const navigate = useNavigate();
    const location = useLocation(); 
  
    const isFirstRender = useRef(true);
  
    let [signer, setSigner] = useState(null);
    let [ip, setIp] = useState('');
    let [loginId, setLoginId] = useState('');
    let [referrerId, setReferrerId] = useState(1);
    let [isConnected, setIsConnected] = useState(0);
    let [balance, setBalance] = useState(0);
    let [userAddress, setUserAddress] = useState('');
    let [usdtAddress, setUsdtAddress] = useState('');
  
    let [totalValue, setTotalValue] = useState(0);
    let [totalValueIp, setIpTotalValue] = useState(0);
    let [totalMembers, setTotalMembers] = useState(0);
  
    const [activeIndex, setActiveIndex] = useState(null);
  
    const notify = (message) => toast(message);
  
    const handleConnectWallet = async () => {
      await connectWallet();
    };
  
    const handleDisconnect = async () => {
      setBalance(0);
      setSigner(null);
      setUserAddress('');
      setIsConnected(false);
      disconnectWallet();
    }
    
    const toggleAccordion = (index) => {
      setActiveIndex(activeIndex === index ? null : index);
    };
  
    useEffect(() => {
      connectWallet();
    }, []);
  
    useEffect(() => {
      AOS.init({ duration: 1500 });
      async function getData() {
        try {
          
          const contract = await getContract();
          const lastIdCount = await contract.lastIDCount()
          setTotalMembers(
            ethers.BigNumber.from(lastIdCount).toNumber()
          );
          
          const valueInvestedBN = await contract.totalValueInvested();
          console.log(valueInvestedBN);
          
          
          const totalInvested = +ethers.utils.formatUnits(valueInvestedBN);
          
          setTotalValue(totalInvested);
          
          const token = await getTokenContract();
          setUsdtAddress(token.address);
          
          // await getBalance();
  
        } catch (error) {
          console.log(error);
        }
      }
      getData();
    }, []);
  
    useEffect(() => {
      if (location.search) {
          const { refid } = queryString.parse(location.search); // Parse URL query params
          console.log(refid);
          
          if (refid) {
              setReferrerId(refid); // Update state with refId from URL
          }
      }
    }, [location.search])
  
    useEffect(() => {
      if(!signer) return
      getBalance();
      
    } , [signer]);
  
    const addToMetamask = async () => {
      try {
        // wasAdded is a boolean. Like any RPC method, an error may be thrown.
        const wasAdded = await window.ethereum.request({
          method: 'wallet_watchAsset',
          params: {
            type: 'ERC20', // Initially only supports ERC20, but eventually more!
            options: {
              address: usdtAddress, // The address that the token is at.
              // address: '0xD6bdfA86136F8390C8513d27C2578fE7e54C89d8', // The address that the token is at.
              symbol: 'USDT', // A ticker symbol or shorthand, up to 5 chars.
              decimals: 18, // The number of decimals in the token
            },
          },
        });
  
        if (wasAdded) {
          console.log('Thanks for your interest!');
        } else {
          console.log('Your loss!');
        }
      } catch (error) {
        console.log(error);
      }
    }
  
    const connectWallet = async () => {
      const wallet = await getWallet();
      if (!wallet.isReadOnly) {
        // if(wallet.isWrongNetwork) {
        //     throw new Error('Switch to Polygon');
        //     return;
        // }
  
        const browserAddresses = await wallet.provider.listAccounts();
        
        setUserAddress(browserAddresses[0]);
        setIsConnected(true);
        setSigner(wallet.signer);
  
      } else {
        // throw new Error('Wallet not connected');
      }
    }
  
    const getBalance = async () => {
      const token = await getTokenContract();
      
      const balance = await token.balanceOf(userAddress);
      if(balance.gt(ethers.BigNumber.from("0"))) {
        const totalBalanceBN = balance.div(ethers.BigNumber.from("1000000000000000000"));
          const totalBalance = ethers.BigNumber.from(totalBalanceBN).toString();
          setBalance(totalBalance);
  
      }
    }
  
    const handleRegister = async () => {
      const wallet = await getWallet();
      if (!isConnected) {
        alert('Connect wallet');
        return;
      }
      try {
        var transactionService = new TransactionService(0, userAddress);
        const registrationPromise = transactionService.register(referrerId);
        const newId = await toast.promise(
          registrationPromise,
          {
            pending: `Joining in process under ID: ${referrerId}`,
            success: 'Joining Successfull',
            error: 'Joining failed'
          },
          {
            position: toast.POSITION.BOTTOM_CENTER 
          }
        )
        console.log(newId);
        
        if (newId > 0) { 
          navigate('/dashboard/' + newId);
        }
      } catch (error) {
        console.log(error);
        alert(error.message);
      }
    } 
  
    const handleViewClick = async () => {
      const contract = await getContract();
      const id = loginId;
      const lastId = ethers.BigNumber.from(
        await contract.lastIDCount()
      ).toNumber();
      if (lastId < id || id < 1) {
        alert(`User Id ${id} not found`);
        return;
      }
      // this.props.router.navigate("/dashboard/" + id);
      navigate("/dashboard/" + id);
    }
  
    const handleLogin = async () => {
      const wallet = await getWallet();
      if (!wallet.isReadOnly) {
        const browserAddresses = await wallet.provider.listAccounts();
        const contract = await getContract();
        const id = ethers.BigNumber.from(
          await contract.getIdByAddress(browserAddresses[0])
        ).toNumber();
        if (id == 0) {
          alert(
            "No id found with your connected wallet make sure switch to joined account on metamask"
          );
          return;
        }
        navigate("/dashboard/" + id);
      }
    };
  
    const accordions = [
      {
        id: 0,
        title: "What is CDL4289?",
        body: "CDL4289 is the global decentralized ecosystem and the first ever smart contract of 2x2 unlimited marketing matrix of the binance networks (BSC). It is a self-executing algorithm that performs the function of distributing partner rewards between community members, subject to certain conditions (matrix marketing plan). The contract code is public available. Transactions can explore or viewed at the link https://bscscan.com"
      },
      {
        id: 1,
        title: "Who manages the platform?",
        body: "Nobody, it is self-executing"
      },
      {
        id: 2,
        title: "Who maded CDL4289",
        body: "Created by group of crypto enthusiasts, who are members of the community and don't have any special privileges. Today, CDL4289 is a peer-to-peer community of platform members, to whom the platform itself belongs."
      },
      {
        id: 3,
        title: "What is a smart contract and its advantages?",
        body: "A smart contract is an algorithm within a cryptocurrency's blockchain. In our case, USDT similar to US Dollar on Polygon chain is our first choice among those on which it is possible to create smart contracts. The main purpose of such contracts is the automation of the relationship, the opportunity to make a commitment self-executing."
      },
      {
        id: 4,
        title: "What is decentralization?",
        body: "The process works based on distributing authority from a centralized administration to the participants involved in the process. Unlike a centralized system, all decisions are made by consensus."
      },
       {
        id: 5,
        title: "Which wallet should I use?",
        body: "CDL4289 works with all crypto wallets. When working with CDL4289: - for all types of EVM wallets like Metamask, Trust Wallet, Tocken Pocket (TP) or etc. These wallets are among the most popular and demanded in the global crypto industry."
      },
      {
        id: 6,
        title: "Where can I get more information about CDL4289?",
        body: "We recommend subscribing to verified CDL4289 Telegram channels or facebook, so that you can ask questions to participants who will be happy to share their experiences."
      },
      {
        id: 7,
        title: "How can I register on the CDL4289 platform?",
        body: "To register with CDL4289, you need to switch to Binance Smart Chain (BSC) and excecute 20 USDT (Tether) to a smart contract to activate your account in platform. Be noted again, it is in the Binance network."
      },
      {
        id: 8,
        title: "Can I register on the website without a partner link?",
        body: "Yes. Registration without an invitation link will put you in the ID1 team."
      },
      {
        id: 9,
        title: "What will happen to my account if I take a break from working with the CDL4289 community?",
        body: "No one can close your account, even if they have a strong desire to do so. The account will always be saved in one of the Binance blocks. You will continue to receive income from all marketing plan."
      },
      {
        id: 10,
        title: "I have activated the platform, what should I do next?",
        body: "To effectively interact with the CDL4289 platform, you need: Talk to the person who invited you or other experienced participants - they will help you take the first steps. And then go to 'Community' for learning more so that you will get successful work on the platform."
      },
      {
        id: 11,
        title: "What is program, and what are levels?",
        body: "The programs 2x2 infinite matrix. Composes of : Direct Referral, Uni-Level and All sales, please learn more in communitie for details."
      },
          {
        id: 12,
        title: "What is Code of Ethics and Conduct for CDL Members",
        body: "1.Members must act with honesty and integrity toward fellow business partners | 2.Members must present the income structure plan accurately and truthfully at all times | 3.Members are strictly prohibited from modifying CDL's income structure plan or promoting it with exaggerated or misleading claims that differ from the official plan and may cause misunderstanding | 4.Members are not allowed to sponsor across different network lines | 5.Members must not use images of other individuals for CDL platform promotion without written consent | 6.Members who violate the code of ethics and conduct will not be eligible to receive welfare benefits in Phase 2 of the CDL platform | 7.The CDL platform holds no responsibility for any actions taken by groups or individuals who violate these rules and ethical guidelines"
      },
  
        ];

  return (    <div id="home" style={{ background: 'linear-gradient(135deg, #0D0B1A 0%, #1A103C 50%, #0D0B1A 100%)' }}>
      <ToastContainer
        position="bottom-center"
        theme="colored"
        autoClose={10000}
        style={{ zIndex: 1 }}
      /> <ToastContainer />

      <Header
        isHome={true}
        userAddress={userAddress}
        onConnectWallet={handleConnectWallet}
        signer={signer}
        onDisconnect={handleDisconnect}
      />
      
      {/* Hero Banner - Purple & Gold Theme */}
      <section
        className="banner"
        style={{ 
          backgroundImage: "url(/logo/BG6.jpg)",
          position: "relative",
          backgroundSize: "cover",
          backgroundPosition: "center"
        }}
      >
        <div className="banner-overlay" style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "linear-gradient(135deg, rgba(26,16,60,0.95) 0%, rgba(106,13,173,0.85) 50%, rgba(255,215,0,0.3) 100%)",
          zIndex: 1
        }}></div>
        <div className="banner-sections" style={{ position: "relative", zIndex: 2 }}>
          <div className="logo-sec" data-aos="fade-right">
            <img
              src="/logo/logo.png"
              style={{ width: "350px", margin: "0 auto", filter: "drop-shadow(0 0 30px rgba(255,215,0,0.5))" }}
              alt="Crypto Digital For Life"
            />
            <h2 style={{ textAlign: "center", marginTop: "20px", color: "#FFD700", fontSize: "2rem", textShadow: "0 0 10px rgba(255,215,0,0.3)" }}>CRYPTO DIGITAL FOR LIFE</h2>
          </div>
          <div className="content-sec" data-aos="fade-left">
            <div className="video-wrapper" style={{ borderRadius: "20px", overflow: "hidden", boxShadow: "0 20px 40px rgba(255,215,0,0.2)" }}>
              <video width="100%" controls>
                <source src="/cdlintro.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
      </section>
      
      {/* Stats Cards - Purple & Gold Theme */}
      <div className="stats-container" style={{ maxWidth: "1200px", margin: "-50px auto 50px", padding: "0 20px", position: "relative", zIndex: 3 }}>
        <div className="grid grid-cols-2 gap-4">
          <div className="stat-card" data-aos="zoom-in" style={{ background: "linear-gradient(135deg, #2D1B4E, #1A103C)", borderRadius: "20px", padding: "25px", textAlign: "center", border: "1px solid rgba(255,215,0,0.3)", boxShadow: "0 10px 30px rgba(0,0,0,0.3)" }}>
            <h3 style={{ fontSize: "clamp(10px, 4vw, 14px)", color: "#FFD700", letterSpacing: "2px", marginBottom: "10px" }}>ACCOUNTS</h3>
            <div style={{ fontSize: "clamp(25px, 6vw, 25px)", fontWeight: "bold", color: "#fff" }}>{totalMembers}</div>
          </div>
          <div className="stat-card" data-aos="zoom-in" data-aos-delay="200" style={{ background: "linear-gradient(135deg, #2D1B4E, #1A103C)", borderRadius: "20px", padding: "25px", textAlign: "center", border: "1px solid rgba(255,215,0,0.3)", boxShadow: "0 10px 30px rgba(0,0,0,0.3)" }}>
            <h3 style={{ fontSize: "clamp(10px, 4vw, 14px)", color: "#FFD700", letterSpacing: "2px", marginBottom: "10px" }}>VOLUMES (USDT)</h3>
            <div style={{ fontSize: "clamp(25px, 6vw, 25px)", fontWeight: "bold", color: "#fff" }}>{totalValue}</div>
          </div>
        </div>
      </div>
      
      {/* Authentication Section - Purple & Gold Theme */}
      <section className="custom-container authentication-section" style={{ maxWidth: "1200px", margin: "0 auto 60px", padding: "0 20px" }}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          
          {/* Left Side - How To Guide */}
          <div className="guide-card" data-aos="fade-right" style={{ background: "rgba(26,16,60,0.7)", backdropFilter: "blur(10px)", borderRadius: "30px", padding: "35px", border: "1px solid rgba(255,215,0,0.3)" }}>
            <div className="section-badge" style={{ display: "inline-block", background: "rgba(255,215,0,0.15)", padding: "5px 15px", borderRadius: "50px", color: "#FFD700", fontSize: "12px", marginBottom: "20px" }}>GET STARTED</div>
            <h3 style={{ fontSize: "28px", marginBottom: "25px", color: "#fff" }}>How To Join</h3>
            
            <div className="step-item" style={{ marginBottom: "25px", paddingLeft: "20px", borderLeft: "3px solid #FFD700" }}>
              <h4 style={{ color: "#FFD700", marginBottom: "8px" }}>Step 1: Connect Wallet</h4>
              <p style={{ color: "#ccc", lineHeight: "1.6" }}>Access via Metamask mobile app or browser extension. Mobile users can use Trust Wallet, Token Pocket (TP), Bitget, or other alternatives.</p>
            </div>
            
            <div className="step-item" style={{ marginBottom: "25px", paddingLeft: "20px", borderLeft: "3px solid #FFD700" }}>
              <h4 style={{ color: "#FFD700", marginBottom: "8px" }}>Step 2: Register Account</h4>
              <p style={{ color: "#ccc", lineHeight: "1.6" }}>Enter your Upline ID and complete registration with just 20 USDT. Your journey begins instantly.</p>
            </div>
            
            <div className="step-item" style={{ marginBottom: "25px", paddingLeft: "20px", borderLeft: "3px solid #FFD700" }}>
              <h4 style={{ color: "#FFD700", marginBottom: "8px" }}>Step 3: Access Dashboard</h4>
              <p style={{ color: "#ccc", lineHeight: "1.6" }}>You'll automatically navigate to Dashboard after joining OR access your dashboard via the homepage Login button.</p>
            </div>
          </div>
          
          {/* Right Side - Login & Register Combined */}
          <div className="auth-card" data-aos="fade-left" style={{ background: "rgba(26,16,60,0.7)", backdropFilter: "blur(10px)", borderRadius: "30px", padding: "35px", border: "1px solid rgba(255,215,0,0.3)" }}>
            
            {/* Login Form */}
            <div className="login-form" style={{ marginBottom: "40px" }}>
              <div className="form-header" style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "20px" }}>
                <div style={{ width: "4px", height: "30px", background: "#FFD700", borderRadius: "2px" }}></div>
                <h3 style={{ fontSize: "24px", color: "#fff", margin: 0 }}>Member Login</h3>
              </div>
              <input 
                onChange={(e) => setLoginId(e.target.value)} 
                value={loginId} 
                id="idbyPlan" 
                type="number" 
                placeholder="Enter Your ID" 
                style={{ width: "100%", padding: "15px", background: "rgba(0,0,0,0.4)", border: "1px solid rgba(255,215,0,0.3)", borderRadius: "15px", color: "#fff", marginBottom: "20px" }}
              />
              <div className="actions" style={{ display: "flex", gap: "15px" }}>
                <button onClick={handleViewClick} className="button lightBtn" style={{ flex: 1, padding: "12px", background: "transparent", border: "1px solid #FFD700", borderRadius: "12px", color: "#FFD700", cursor: "pointer", transition: "all 0.3s ease" }}>View Profile</button>
                <button onClick={handleLogin} className="button whiteBtn" style={{ flex: 1, padding: "12px", background: "linear-gradient(90deg, #FFD700, #B8860B)", border: "none", borderRadius: "12px", color: "#1A103C", cursor: "pointer", fontWeight: "bold" }}>Login</button>
              </div>
            </div>
            
            {/* Divider */}
            <div style={{ display: "flex", alignItems: "center", gap: "15px", margin: "30px 0" }}>
              <div style={{ flex: 1, height: "1px", background: "rgba(255,215,0,0.3)" }}></div>
              <span style={{ color: "#FFD700", fontSize: "12px" }}>NEW MEMBER?</span>
              <div style={{ flex: 1, height: "1px", background: "rgba(255,215,0,0.3)" }}></div>
            </div>
            
            {/* Register Form */}
            <div className="register-form">
              <div className="form-header" style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "20px" }}>
                <div style={{ width: "4px", height: "30px", background: "#FFD700", borderRadius: "2px" }}></div>
                <h3 style={{ fontSize: "24px", color: "#fff", margin: 0 }}>Create Account</h3>
              </div>
              <div className="requireAmount" style={{ marginBottom: "8px" }}>
                <span style={{ color: "#ccc" }}>Upline / Referrer ID</span>
              </div>
              <input 
                onChange={(e) => setReferrerId(e.target.value)} 
                value={referrerId} 
                id="idbyPlan" 
                type="number" 
                placeholder="Enter Upline ID" 
                style={{ width: "100%", padding: "15px", background: "rgba(0,0,0,0.4)", border: "1px solid rgba(255,215,0,0.3)", borderRadius: "15px", color: "#fff", marginBottom: "15px" }}
              />
              <div className="requireAmount" style={{ background: "rgba(255,215,0,0.1)", padding: "12px", borderRadius: "12px", marginBottom: "12px" }}>
                <span style={{ color: "#FFD700" }}>⚡ Registration Fee: 20 USDT</span>
              </div>
              <span className="balance" style={{ display: "block", marginBottom: "20px", color: "#ccc", fontSize: "14px" }}>Your USDT balance: {balance} </span>
              <div className="actions">
                <button onClick={handleRegister} className="button whiteBtn" style={{ width: "100%", padding: "14px", background: "linear-gradient(90deg, #FFD700, #B8860B)", border: "none", borderRadius: "12px", color: "#1A103C", cursor: "pointer", fontWeight: "bold", fontSize: "16px" }}>Register Now</button>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* FAQ Section - Purple & Gold Theme */}
      <section className="faq-section" style={{ background: "linear-gradient(180deg, #0D0B1A 0%, #1A103C 100%)", padding: "70px 20px" }}>
        <div className="custom-container roadmap" style={{ maxWidth: "1000px", margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: "50px" }}>
            <span style={{ display: "inline-block", background: "rgba(255,215,0,0.15)", padding: "5px 15px", borderRadius: "50px", color: "#FFD700", fontSize: "12px", marginBottom: "15px" }}>KNOWLEDGE BASE</span>
            <h6 className="section-heading" data-aos="fade-up" style={{ fontSize: "36px", marginBottom: "15px", color: "#fff" }}>
              Frequently Asked Questions
            </h6>
            <span data-aos="fade-up" style={{ color: "#ccc" }}>
              Major frequently Asked Questions (FAQ) by below, strongly recommend to join our communities of social network for more details.
            </span>
          </div>
          <div className="qna" data-aos="fade-up">
            <div
              className="panel-group"
              id="accordion"
              role="tablist"
              aria-multiselectable="true"
              style={{ display: "flex", flexDirection: "column", gap: "15px" }}
            >
              {accordions.map((item) => (
                <div key={item.id} className="panel panel-default" style={{ background: "rgba(26,16,60,0.6)", backdropFilter: "blur(10px)", borderRadius: "20px", overflow: "hidden", border: "1px solid rgba(255,215,0,0.2)" }}>
                  <div className="panel-heading" role="tab" style={{ padding: "18px 25px", cursor: "pointer" }}>
                    <h4 className="panel-title" style={{ margin: 0 }}>
                      <a
                        className={activeIndex === item.id ? "" : "collapsed"}
                        role="button"
                        onClick={() => toggleAccordion(item.id)}
                        aria-expanded={activeIndex === item.id}
                        style={{ display: "flex", justifyContent: "space-between", alignItems: "center", color: "#fff", textDecoration: "none" }}
                      >
                        <span style={{ fontSize: "18px", fontWeight: "500" }}>{item.title}</span>
                        <span style={{ color: "#FFD700", fontSize: "24px" }}>{activeIndex === item.id ? "−" : "+"}</span>
                      </a>
                    </h4>
                  </div>
                  <div
                    className={`panel-collapse collapse ${
                      activeIndex === item.id ? "show" : ""
                    }`}
                    role="tabpanel"
                    style={{ padding: activeIndex === item.id ? "0 25px 25px 25px" : "0 25px", maxHeight: activeIndex === item.id ? "500px" : "0", overflow: "hidden", transition: "all 0.3s ease" }}
                  >
                    <div className="panel-body">
                      <p style={{ color: "#ccc", lineHeight: "1.6", margin: 0 }}>{item.body}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      
      {/* Code of Ethics Banner - Purple & Gold Theme */}
      <div style={{ maxWidth: "1000px", margin: "40px auto", padding: "0 20px" }}>
        <div style={{ background: "linear-gradient(135deg, rgba(255,215,0,0.1), rgba(106,13,173,0.2))", borderRadius: "20px", padding: "30px", border: "1px solid rgba(255,215,0,0.3)", textAlign: "center" }}>
          <h3 style={{ color: "#FFD700", marginBottom: "15px" }}>📜 Code of Ethics & Conduct</h3>
          <p style={{ color: "#ccc", fontSize: "14px", lineHeight: "1.6" }}>
            Members must act with honesty, present accurate income plans, avoid misleading claims, respect network lines, and obtain consent for using images. Violations may affect welfare benefits.
          </p>
        </div>
      </div>
      
      <Footer />
    </div>);
};

export default Home;